import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/unsubscribe")({
  validateSearch: (s: Record<string, unknown>) => ({ token: (s.token as string) ?? "" }),
  head: () => ({ meta: [{ title: "Abmelden, OM Selected" }, { name: "robots", content: "noindex" }] }),
  component: UnsubscribePage,
});

function UnsubscribePage() {
  const { t } = useTranslation();
  const { token } = useSearch({ from: "/unsubscribe" });
  const [state, setState] = useState<"loading" | "valid" | "already" | "invalid" | "done" | "error">("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    fetch(`/email/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => r.ok ? r.json() : Promise.reject())
      .then((d) => setState(d.valid ? "valid" : "already"))
      .catch(() => setState("invalid"));
  }, [token]);

  async function confirm() {
    setBusy(true);
    try {
      const r = await fetch("/email/unsubscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
      const d = await r.json();
      setState(d.success ? "done" : d.reason === "already_unsubscribed" ? "already" : "error");
    } catch { setState("error"); }
    finally { setBusy(false); }
  }

  return (
    <div className="mx-auto max-w-md px-5 py-24 text-center">
      <div className="eyebrow text-muted-foreground">OM Selected</div>
      <h1 className="serif text-3xl mt-4">{t("unsubscribe.title")}</h1>
      <div className="mt-8 text-sm text-muted-foreground">
        {state === "loading" && t("unsubscribe.loading")}
        {state === "invalid" && t("unsubscribe.invalid")}
        {state === "already" && t("unsubscribe.already")}
        {state === "done" && t("unsubscribe.done")}
        {state === "error" && t("unsubscribe.error")}
        {state === "valid" && (
          <>
            <p className="mb-6">{t("unsubscribe.prompt")}</p>
            <button disabled={busy} onClick={confirm}
              className="eyebrow bg-foreground text-background px-4 py-2 disabled:opacity-50">
              {busy ? t("common.ellipsis") : t("unsubscribe.confirm")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}